import React from 'react'
import { Modal } from "../../../common/modal";

export default function ActivateModal({showModal, handleCancel, onSave}) {
  return (
    <Modal
      title="Activate Discount Policy"
      open={showModal}
      primaryButtonText="Activate"
      secondaryButtonText="Cancel"
      onPrimary={onSave}
      onSecondary={handleCancel}
      setOpen={handleCancel}
    >
      <p>Are you sure you want to activate this policy? This will update prices for customers and line item transactions.</p>
    </Modal>
  )
}
